// extracted by mini-css-extract-plugin
export var tosLink = "_51-0";